export function Loading({ label = 'Loading…', className }: { label?: string; className?: string }) {
  return (
    <div className={`flex items-center justify-center gap-2 py-10 text-sm text-white/60 ${className ?? ''}`}>
      <span className="h-2 w-2 animate-pulse rounded-full bg-[var(--wg-primary)]" />
      {label}
    </div>
  )
}
